<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    // 页面刷新时记住当前路由跟参数
    window.addEventListener("beforeunload", () => {
      if (this.$route.name && this.$route.name !== 'home' && this.$route.name !== 'not_found') {
        window.sessionStorage.setItem('hisHash', this.$route.name);
        window.sessionStorage.setItem('hisHashParam', JSON.stringify(this.$route.query));
      }
    });
  }
}
</script>

<style>
  html, body {
    height: 100%;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%; height: 100%;
    min-width: 1200px;
    min-height: 625px;
  }
</style>
